<template>
    <v-row justify="center">
        <v-dialog v-model="create_new_lead_model" max-width="50%" persistent scrollable>
            <v-card class="leads-dialog-card">
                <div class="leads-dialog-header pa-5">
                    <div class="d-flex align-center justify-space-between">
                        <div class="leads-dialog-title">
                            <v-icon class="mr-2" color="white" size="20">mdi-account-plus-outline</v-icon>
                            Create New Lead
                        </div>
                        <v-btn icon dark @click="eventCloseCreateNewLead()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>
                <v-card-text class="pa-6">
                    <v-form ref="lead_form_data">
                        <v-row class="lead-form-grid">
                            <v-col cols="12">
                                <label class="form-label">Advisor <span class="required-field">*</span></label>
                                <v-autocomplete v-model="lead.advisor_id" outlined dense
                                    placeholder="Select Advisor" item-text="name" item-value="id"
                                    :items="getAdvisors" required
                                    :rules="[v => !!v || 'You are required to select an Advisor for this lead.']"></v-autocomplete>
                            </v-col>
                            <v-col cols="6">
                                <label class="form-label">First Name <span class="required-field">*</span></label>
                                <v-text-field v-model="lead.first_name" outlined dense
                                    placeholder="Enter First Name" type="text" required :rules="[
                                        v => !!v || 'You are required to enter the first name of the organizer for this lead.'
                                    ]"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <label class="form-label">Last Name</label>
                                <v-text-field v-model="lead.last_name" outlined dense placeholder="Enter Last Name"
                                    type="text"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <label class="form-label">Email <span class="required-field">*</span></label>
                                <v-text-field v-model="lead.email" outlined dense placeholder="Enter Email"
                                    type="text" required :rules="[
                                        v => !!v || 'You are required to enter the email address of the organizer for this lead.'
                                    ]"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <label class="form-label">Mobile Number</label>
                                <v-text-field v-model="lead.phone" outlined dense placeholder="Enter Mobile Number"
                                    type="text"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <label class="form-label">Event Type <span class="required-field">*</span></label>
                                <v-select v-model="lead.event_type_id" :items="getEventTypes" item-text="name"
                                    item-value="id" outlined dense placeholder="Select Event Type"
                                    required :rules="[
                                        v => !!v || 'You are required to select an event type for this lead.'
                                    ]">
                                </v-select>
                            </v-col>
                            <v-col cols="6">
                                <label class="form-label">Stag or Hen Name</label>
                                <v-text-field v-model="lead.stag_or_hen_name" outlined dense
                                    placeholder="Enter Stag or Hen Name" type="text"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <label class="form-label">Party Location <span class="required-field">*</span></label>
                                <v-autocomplete v-model="lead.location_id" :items="getLocation" item-text="name"
                                    item-value="id" outlined dense placeholder="Select Party Location"
                                    required :rules="[
                                        v => !!v || 'You are required to select a party location for this lead.'
                                    ]"></v-autocomplete>
                            </v-col>
                            <v-col cols="6">
                                <label class="form-label">Party Date <span class="required-field">*</span></label>
                                <v-menu ref="menu" v-model="party_date.menu" :close-on-content-click="false"
                                    :return-value.sync="party_date.date" min-width="auto">
                                    <template v-slot:activator="{on, attrs}">
                                        <v-text-field v-model="party_date.formatted_date" outlined dense
                                            placeholder="Select a Party Date to start." type="text" v-bind="attrs"
                                            v-on="on" required :rules="[
                                                v => !!v || 'You are required to select a party date for this lead.'
                                            ]">
                                        </v-text-field>
                                    </template>
                                    <v-date-picker v-model="party_date.date" @change="eventSave"
                                        :min="new Date().toISOString()" :events="addPartyActivities"
                                        event-color="green"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="6">
                                <label class="form-label">Nights <span class="required-field">*</span></label>
                                <v-text-field v-model="lead.duration" outlined dense placeholder="Enter No. of Nights"
                                    type="number" required :rules="[
                                        v => (v !== null && v !== undefined && v !== '') || 'You are required to enter the number of nights for this lead.',
                                        v => (v >= 0) || 'The number of nights cannot be negative for this lead.'
                                    ]"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <label class="form-label">Group Size <span class="required-field">*</span></label>
                                <v-text-field v-model="lead.people" outlined dense placeholder="Enter Group Size"
                                    type="number" required :rules="[
                                        v => !!v || 'You are required to enter the number of poeople for this lead.',
                                        v => (v > 0) || 'The number of poeople must be at least one (1) for this lead.'
                                    ]"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <label class="form-label">Message</label>
                                <v-textarea v-model="lead.message" outlined dense auto-grow rows="4"
                                    placeholder="Enter Message"></v-textarea>
                            </v-col>
                            <v-col cols="6">
                                <label class="form-label">Quote Basket Items</label>
                                <v-textarea v-model="lead.quote_basket_items" outlined dense auto-grow rows="4"
                                    placeholder="Enter Quote Basket Items"></v-textarea>
                            </v-col>
                                <!-- <div>
                                    <label class="form-label">Password <span class="required-field">*</span></label>
                                    <v-text-field
                                        v-model="lead.password"
                                        outlined
                                        dense
                                        placeholder="Enter Password"
                                        :type="show_password ? 'text' : 'password'"
                                        :append-icon="show_password ? 'mdi-eye-off' : 'mdi-eye'"
                                        @click:append="show_password = !show_password"
                                        tabindex="11"
                                        autocomplete="new-password"
                                        required
                                        :rules="[
                                            v => !!v || 'You are required to enter the password of the organizer for this lead.'
                                        ]"></v-text-field>
                                </div>
                                <div>
                                    <label class="form-label">Confirm Password</label>
                                    <v-text-field
                                        v-model="confirm_password"
                                        outlined
                                        dense
                                        placeholder="Enter Confirm Password"
                                        :type="show_confirm_password ? 'text' : 'password'"
                                        :append-icon="show_confirm_password ? 'mdi-eye-off' : 'mdi-eye'"
                                        @click:append="show_confirm_password = !show_confirm_password"
                                        tabindex="12"
                                        required
                                        :rules="[
                                            v => (v === this.lead.password) || 'The password you enter does not match with the confirmed password.'
                                        ]"></v-text-field>
                                </div> -->
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-divider />
                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn text class="leads-btn" @click="eventCloseCreateNewLead()">Cancel</v-btn>
                    <v-btn depressed dark color="#3988AA" class="leads-btn" @click="eventSaveNewlyCreatedLead()">
                        <v-icon small left>mdi-check</v-icon>
                        Create
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { lookups } from '@/common/companyLookups';

export default {
    props: {
        show_create_new_lead_dialog: Boolean
    },
    data: () => ({
        create_new_lead_model: false,
        lead: {
            advisor_id: 0,
            duration: 1,
            event_type_id: null,
            start_date: null,
            location_id: null,
            first_name: null,
            last_name: null,
            phone: null,
            email: null,
            password: null,
            people: 1,
            company_id: null,
            stag_or_hen_name: null,
            message: null,
            quote_basket_items: null
        },
        party_date: {
            menu: false,
            date: new Date().toISOString().split("T")[0],
            formatted_date: new Date().toLocaleDateString(),
        },
        show_password: false,
        show_confirm_password: false,
        confirm_password: null,
        classes: {
        }
    }),
    async mounted() {
    },
    computed: {
        getAdvisors() {
            return lookups.advisors
        },
        getLocation() {
            return lookups.locations
        },
        getEventTypes() {
            return lookups.event_types
        },
        ...mapGetters({
            get_selected_company:   'auth/get_selected_company',
        }),
        addPartyActivities() {
            let number_of_days = 0;
            return [...Array(parseInt(this.lead.duration))].map( () => {
                const event_date = new Date(this.party_date.date)
                number_of_days = number_of_days + 1
                event_date.setDate(event_date.getDate() + number_of_days)
                return event_date.toISOString().substr(0, 10)
            })
        }
    },
    methods: {
        ...mapActions({
            
        }),
        eventCloseCreateNewLead() {
            this.$emit('eventCloseCreateNewLead')
        },
        eventSave(party_date) {
            this.$refs.menu.save(party_date)
            this.party_date.formatted_date = new Date(party_date).toLocaleDateString()
        },
        async eventSaveNewlyCreatedLead() {
            const valid = this.$refs.lead_form_data.validate()
            if ( valid ) {
                // TODO:
                this.lead.start_date = this.party_date.date
                this.lead.company_id = this.get_selected_company.id
                const response = await this.$axios.post('admin/leads/create_lead', this.lead)
                const lead_data = response.data
                if (lead_data.response == true) {
                    this.$emit('eventLeadCreated')
                    this.$toast.success('You have successfully created a new lead.', {timeout: 2000, icon: true})
                } else {
                    this.$toast.error(lead_data.message || `${response.status}: ${response.statusText}`)
                }
                
            }
        }
    },
    watch: {
        show_create_new_lead_dialog() {
            this.create_new_lead_model = this.show_create_new_lead_dialog
        }
    }
}

</script>

<style lang="scss" scoped>
.leads-dialog-card {
    border-radius: 12px !important;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    max-height: 90vh;
}

.leads-dialog-card > .v-card__text {
    overflow-y: auto;
    flex: 1;
}

.leads-dialog-header {
    background: linear-gradient(135deg, #3988AA 0%, #2a6a88 100%);
}

.leads-dialog-title {
    font-family: Manrope;
    font-size: 18px;
    font-weight: 700;
    color: white;
    display: flex;
    align-items: center;
}

.leads-btn {
    font-family: Manrope;
    font-weight: 600 !important;
    font-size: 13px !important;
    text-transform: none;
}

.form-label {
    font-family: Manrope;
    font-size: 12px;
    font-weight: 700;
    color: #7C7C7C;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    display: block;
    margin-bottom: 4px;
}

.required-field {
    color: #E53935;
}

.lead-form-grid > .col {
    padding-top: 0;
    padding-bottom: 0;
}
</style>